import React from "react";
import { observer } from "mobx-react";

import "./style/report-document-sections.scoped.scss";

const ReportDocumentMetaData = observer(({ data }) => {
    return (
        <div className="sectionsContainer">
            <div>
                <b>Name:</b> {data.label}
            </div>
            <div>
                <b>Template:</b> {data.key}
            </div>
            <div>
                <b>Value:</b> {data.value}
            </div>
        </div>
    );
});

export default ReportDocumentMetaData;
